<template>
    <div>
        <a-modal :title="title" v-model="visible" @ok="handleOk"  class="set-model">
            <a-form :form="form"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 12 }"
            >
                    <a-form-item label="登录账号">
                        <a-input placeholder="请输入登录账户"
                                 @pressEnter="handleOk"
                                 autocomplete="off"
                                 v-decorator="['loginName', { rules: [{ required: true, message: '请输入登录账户' }] }]" />
                    </a-form-item>
            </a-form>
        </a-modal>
        <a-modal :title="title1" v-model="visible1" @ok="handleOk1"  class="set-model set-model1">
            <a-form :form="form1"
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 16 }"
            >
                <a-form-item label="新手机号">
                    <a-input placeholder="请输入新手机号码"
                             type="number"
                             ref="inputMobile"
                             :maxLength="11"
                             autocomplete="off"
                             @change="onInputMobile"
                             v-decorator="['mobile', { rules: [{ required: true, message: '请输入新手机号码' }] }]" />
                </a-form-item>
                <a-form-item label="验证码" style="display: flex">
                    <a-input placeholder="请输入手机验证码" style="width: 245px"  type="number"
                             @pressEnter="handleOk1"
                             autocomplete="off"
                             v-decorator="['verifyCode', { rules: [{ required: true, message: '请输入手机验证码' }] }]" />
                    <div class="basic-code" :class="numberInput.length == 11 ? 'basic-code-active' :''" @click="btnVerificationCode">{{ time>0?time+'S后重试' :'获取验证码' }}</div>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
    import {sendCode} from "@/utils/api";
export default {
  name: 'setPassModel',
  data () {
    return {
      title: '账户设置',
      visible: false,
      form: this.$form.createForm(this),
        visible1:false,
        title1:'修改手机号',
        form1: this.$form.createForm(this),
        timer: null,
        time: 0,
        numberInput:'',
        tabIndex:'',
        verifyKey:'',
    }
  },
  methods: {
    show (index) {
        this.tabIndex = index
        if(index == 1){
            this.form = this.$form.createForm(this)
            this.visible = true
        }else if(index == 2){
            this.form1 = this.$form.createForm(this)
            this.visible1 = true
        }
    },
    cancel () {
      this.visible = false
        this.visible1 = false
    },
    handleOk () {
        this.form.validateFields((err, values) => {
            if(!err){
                this.$emit('confirmModel',values,this.verifyKey,this.tabIndex)
            }
        })
    },
      onCancel1(){
          this.visible = false
          this.visible1 = false
      },
      onInputMobile(){
          setTimeout(()=>{
              this.numberInput = this.$refs.inputMobile.value
          },20)
      },
      /**
       * @description: 获取验证码（方法描述）
       */
      btnVerificationCode(){
          if(this.numberInput.length != 11){
              return
          }
          console.log(this.timer)
          if(!this.timer){
              if(!this.isEmpty(this.numberInput)){
                  let data = new FormData()
                  data.append('mobile',this.numberInput)
                  sendCode(data,{}).then((res)=>{
                      if(res.success){
                          this.verifyKey = res.result.key
                          this.$message.success('信息已经发到您的手机上了~')
                          this.resetTime()
                      }
                  })
              }else{
                  this.$message.warn('请输入手机号')
              }
          }else{
              this.$message.success('信息已经发到您的手机上了~')
          }
      },
      resetTime(){
          this.time = 60
          this.timer = setInterval(()=>{
              if(this.time > 0){
                  this.time--
              }else{
                  clearInterval(this.timer)
                  this.timer = null
                  this.time = 0
              }
          },1000)
      },
      handleOk1(){
          this.form1.validateFields((err, values) => {
              if(!err){
                  this.$emit('confirmModel',values,this.verifyKey,this.tabIndex)
              }
          })
      }
  }
}
</script>

<style lang="scss">
    .set-model{
        width: 580px !important;
        height: 300px !important;
        .ant-form-item-children{
            display: flex;
        }
    }
    .set-model1{
        width: 580px !important;
        height: 340px !important;
    }
</style>
<style scoped lang="scss">
    .basic-code{
        width:106px;
        height:36px;
        line-height: 36px;
        background:rgba(250,250,250,1);
        border:1px solid rgba(229,229,229,1);
        border-radius:6px;
        color: #AAAAAA;
        text-align: center;
        margin-left: 10px;
        cursor: pointer;
    }
    .basic-code-active{
        background-color: var(--co);
        color: #fff;
    }
</style>
